<template>
    <form>
        <div class="d-flex w-100 mt-2">
            <div class="d-flex flex-column align-items-sm-baseline">
                <b-form-checkbox
                    :id="'only_ticket_' + scheduler.id"
                    v-model="form.only_ticket"
                    :name="'only_ticket_' + scheduler.id"
                >
                    Solo ticket
                </b-form-checkbox>
            </div>
        </div>
        <div class="d-flex w-100 mt-2">
            <div class="d-flex flex-column align-items-sm-baseline">
                <label>Nombre personalizado corto</label>
                <b-form-input
                    type="text"
                    :id="'custom_name_' + scheduler.id"
                    v-model="form.custom_name"
                    :name="'custom_name_' + scheduler.id"
                >
                    
                </b-form-input>
            </div>
        </div>
        <div class="d-flex w-100" v-if="!form.only_ticket">
            <div class="d-flex flex-column align-items-sm-baseline">
                <label>Grupo <span class="text-danger"></span></label>
                <b-form-select v-model="form.groupId" style="width: 17vw; border:none;">
                    <option value="0">Seleccione grupo...</option>
                    <optgroup v-for="grouped in organizeGroups" :key="grouped.suprazone_name" :label="grouped.suprazone_name">
                        <option v-for="group in grouped.groupsList" :key="group.id" :value="group.id">{{group.name}}</option>
                    </optgroup>
                </b-form-select>
            </div>
        </div>
        <div class="d-flex w-100" v-if="!form.only_ticket">
            <div class="d-flex flex-column align-items-sm-baseline">
                <label>Duración <span class="text-danger"></span></label>
                <b-form-select v-model="form.durationId" style="width: 17vw; border:none;">
                    <option value="0">Seleccione duración...</option>
                    <option v-for="duration in activityDurationTypes" :key="duration.id" :value="duration.id">{{duration.name}}</option>
                </b-form-select>
            </div>
        </div>

        <div class="d-flex w-100" v-if="form.only_ticket">
            <div class="d-flex flex-column align-items-sm-baseline">
                <label>Punto encuentro / Inicio <span class="text-danger"></span></label>

                <v-select
                    :options="geopointsListAdmin"
                    :reduce="(option) => option.id"
                    
                    label="name"
                    v-model="form.geopointId"
                    style="width: 17vw;"
                    class="border "
                >
                </v-select>

            </div>
        </div>

        <div class="d-flex w-100 mt-2" v-if="form.only_ticket">
            <div class="d-flex flex-column align-items-sm-baseline">
                <label>Hora inicio en el punto de inicio</label>
                <b-form-input
                    type="time"
                    :id="'begin_hour_' + scheduler.id"
                    v-model="form.beginHour"
                    :name="'begin_hour_' + scheduler.id"
                >
                    
                </b-form-input>
            </div>
        </div>



        <div class="d-flex w-100 mt-2" v-if="!form.only_ticket">
            <div class="d-flex flex-column align-items-sm-baseline">
                <b-form-checkbox
                    :id="'pickup_service_' + scheduler.id"
                    v-model="form.pickup_service"
                    :name="'pickup_service_' + scheduler.id"
                    
                >
                    Con servicio de bus de recogida
                </b-form-checkbox>
            </div>
        </div>
        <div class="d-flex w-100 mt-2" v-if="!form.only_ticket">
            <div class="d-flex flex-column align-items-sm-baseline">
                <b-form-checkbox
                    :id="'excursion_service_' + scheduler.id"
                    v-model="form.excursion_service"
                    :name="'excursion_service_' + scheduler.id"
                    
                >
                    Con servicio de bus de excursión
                </b-form-checkbox>
            </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
            <b-button @click="save" class="text-white" variant="primary">
                <i class="fa fa-check-circle mr-2" aria-hidden="true"></i>
                <span>Guardar</span>
            </b-button>
        </div>
    </form>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

export default {
    props: {
        currentGroup: {
            type: Object,
            required: true,
        },
        scheduler: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            form: {
                groupId: this.currentGroup != null ? this.currentGroup.id : null,
                durationId: this.scheduler != null && this.scheduler.activity_duration_type != null ? this.scheduler.activity_duration_type.id : null,
                pickup_service: this.scheduler != null ? this.scheduler.pickup_service: true,
                excursion_service: this.scheduler != null ? this.scheduler.excursion_service: true,
                only_ticket: this.scheduler != null ? this.scheduler.only_ticket: false,
                custom_name: this.scheduler != null ? this.scheduler.custom_name: '',
                geopointId: this.scheduler != null && this.scheduler.begin_geopoint != null ? this.scheduler.begin_geopoint.id : null,
                beginHour: this.scheduler != null ? this.scheduler.begin_hour : null
            },
            
        }
    },
    async mounted() {
        //await this.$store.dispatch("suprazones/loadSuprazones")

        
    },
    methods: {
        async save() {
            if ( !this.form.only_ticket && this.form.groupId == null) {
                this.$notify({
                    group: "foo",
                    title: "No se puede editar",
                    text: 'Para guardar los cambios, se tiene que seleccionar "only ticket" o elegir un group de actividad',
                    type: "error"
                });
                return
            }
            let payload = {
                activity_id: this.scheduler.id
            }
            if ( this.form.only_ticket ) {
                payload.data = {
                    //activity_group_id: this.form.groupId,
                    //activity_duration_type_id: this.form.durationId,
                    pickup_service: false,
                    excursion_service: false,
                    only_ticket: true,
                    custom_name: this.form.custom_name,
                    begin_geopoint_id: this.form.geopointId,
                    begin_hour: this.form.beginHour
                }
            } else {
                payload.data = {
                    activity_group_id: this.form.groupId,
                    activity_duration_type_id: this.form.durationId,
                    pickup_service: this.form.pickup_service,
                    excursion_service: this.form.excursion_service,
                    only_ticket: false,
                    custom_name: this.form.custom_name,
                    begin_geopoint_id: 0,
                    begin_hour: ''
                }
            }
            await this.$store.dispatch("activities/activity_set_group", payload)
            .then(response => {
                this.$notify({
                    group: "foo",
                    title: "Scheduler editado",
                    text: "Se ha editado el scheduler",
                    type: "success"
                });
            })
            .catch(error => {
                console.log(error)
                this.$notify({
                    group: "foo",
                    title: "El scheduler no se ha podido editar",
                    text: error.response.data,
                    type: "error"
                });
            })
            //this.$store.dispatch("activities/get_activities")
            
        }
    },
    computed: {
    ...mapGetters(["groups", "activityDurationTypes", "suprazones", "geopointsListAdmin"]),
    organizeGroups() {
        let org = []
        for ( let i in this.suprazones ) {
            const grps = this.groups
            let fGroups = grps.filter( (group) => group.suprazone_name == this.suprazones[i].name )
            org.push({
                suprazone_name: this.suprazones[i].name,
                groupsList: fGroups
            })
        }

        return org
    },
  }
}
</script>